import { connect } from "react-redux";
import flowRight from "lodash.flowright";

//UI Processors
import SingleValueReduxUtil from "src/ui_processors/single_value";

//HOC
import {
  withResourceLoaderFactory,
  withLoadingComponentFactory
} from "src/hoc/factories";

//Component
import { AdminWoundAlertRulesTableComponent } from "src/components/tables";

//Selectors
import { rulesResourceSelectors } from "src/selectors/data_selectors";
import { createWoundAlertRulesQuerySelector } from "src/selectors/api_selectors/admin/rules";
import { adminSectionSelector } from "src/selectors/section_selectors/admin";
const selectedWoundAlertRulesTablePageLimitSelector = SingleValueReduxUtil.createSelectors(
  "selectedWoundAlertRulesTablePageLimit",
  adminSectionSelector
);
const selectedWoundAlertRulesTablePageNumberSelector = SingleValueReduxUtil.createSelectors(
  "selectedWoundAlertRulesTablePageNumber",
  adminSectionSelector
);
//Actions
import { loadRulesAction } from "src/actions/data_actions";
import {
  selectWoundAlertRulesTablePageLimitAction,
  selectWoundAlertRulesTablePageNumberAction
} from "src/actions/section_actions/admin";

//Constants
import { analyticsEventNames } from "src/constants";

function mapStateToProps(state) {
  const context = createWoundAlertRulesQuerySelector()(state);

  return {
    context,
    rules: rulesResourceSelectors.createDataForContextSelector(
      createWoundAlertRulesQuerySelector()
    )(state),
    pageLimit: selectedWoundAlertRulesTablePageLimitSelector.fieldSelector(
      state
    ),
    currentPage: selectedWoundAlertRulesTablePageNumberSelector.fieldSelector(
      state
    ),
    pageCount:
      rulesResourceSelectors.createPageCountSelector(
        context,
        selectedWoundAlertRulesTablePageLimitSelector.fieldSelector
      )(state) || 0
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendSetPageLimitAction: limit => {
      dispatch(selectWoundAlertRulesTablePageLimitAction(limit));
    },
    sendSetPageAction: pageNumber => {
      dispatch(selectWoundAlertRulesTablePageNumberAction(pageNumber));
    }
  };
}

export const AdminWoundAlertRulesTableContainer = flowRight(
  withResourceLoaderFactory({
    getResourceAction: loadRulesAction,
    resourceSelectors: rulesResourceSelectors,
    createContextSelector: createWoundAlertRulesQuerySelector,
    createQuerySelector: createWoundAlertRulesQuerySelector
  }),
  withLoadingComponentFactory({
    analyticsEventName: analyticsEventNames.renderAdminWoundAlertRulesTable
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AdminWoundAlertRulesTableComponent);
